import { createStyles, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: "90vw",
    },
    header: {
      marginBottom: theme.spacing(2),
      "& > h2": {
        marginBottom: 0,
        display: "inline-block",
      },
    },
    hiddenButton: {
      fontSize: "inherit",
      fontFamily: "inherit",
      border: 0,
      padding: 0,
      lineHeight: 1,
      backgroundColor: "transparent",
      cursor: "pointer",
    },
  }),
);

export default useStyles;
